<template>
    <div v-if="hasSelection || !shouldHideEmpty" class="sf__header-selection" :class="{ 'is-open': sheetOpen, 'has-selection': hasSelection }">
        <button
            v-if="!hasSelection"
            type="button"
            class="button button--secondary vehicle-trigger-btn nav-vehicle-trigger-btn sf__header-selection__fallback"
            :class="{ 'header__cta-mobile': isMenu }"
            @click.prevent.stop="openDrawer()"
        >
            Find My Vehicle
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M10.707 17.707L16.414 12L10.707 6.29297L9.29297 7.70697L13.586 12L9.29297 16.293L10.707 17.707Z" fill="#DE4527"/>
            </svg>
        </button>

        <template v-else>
            <button
                type="button"
                class="sf__header-selection__card"
                :aria-expanded="sheetOpen ? 'true' : 'false'"
                aria-haspopup="dialog"
                @click="toggleSheet"
            >
                <span class="sf__header-selection__icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3379 10.3174C14.9342 10.1808 15.5524 10.163 16.1543 10.2646L16.4111 10.3164L16.4766 10.3389C16.538 10.369 16.588 10.42 16.6172 10.4834L17.1221 11.5811L18.375 11.4512H18.4424C18.5087 11.4593 18.5712 11.4896 18.6191 11.5381C19.1025 12.0285 19.4597 12.6224 19.6611 13.2715C19.6899 13.3643 19.6723 13.4657 19.6133 13.543L18.8809 14.5L19.6133 15.458C19.6724 15.5354 19.6902 15.6366 19.6611 15.7295C19.5623 16.0459 19.4253 16.3567 19.2451 16.6553L19.2441 16.6543C19.0689 16.9458 18.8595 17.2167 18.6191 17.4609C18.5551 17.526 18.4648 17.5583 18.374 17.5488L17.1211 17.418L16.6172 18.5156C16.5783 18.6 16.5027 18.6619 16.4121 18.6826C15.7307 18.8388 15.0206 18.8387 14.3389 18.6836C14.248 18.6629 14.1718 18.6013 14.1328 18.5166L13.627 17.418L12.375 17.5488C12.2846 17.5581 12.1948 17.5266 12.1309 17.4619C11.6474 16.9714 11.2903 16.3774 11.0889 15.7285C11.0601 15.6357 11.0777 15.5342 11.1367 15.457L11.8682 14.499L11.1367 13.542C11.0776 13.4646 11.0598 13.3635 11.0889 13.2705C11.1877 12.9541 11.3247 12.6433 11.5049 12.3447C11.6801 12.0533 11.8905 11.7832 12.1309 11.5391L12.1836 11.4961C12.2402 11.46 12.3079 11.4441 12.376 11.4512L13.6279 11.5811L14.1328 10.4844L14.168 10.4258C14.21 10.3717 14.2698 10.333 14.3379 10.3174ZM15.7812 11.3145C15.5109 11.2832 15.2381 11.2839 14.9678 11.3154L14.5508 12.2246C14.4795 12.3792 14.3592 12.5059 14.2109 12.5879C14.0628 12.6698 13.8927 12.7041 13.7246 12.6865L12.6846 12.5781C12.5256 12.7812 12.3928 13.0009 12.2881 13.2334L12.8965 14.0283C12.9999 14.1637 13.0566 14.3291 13.0566 14.5C13.0566 14.6709 12.9999 14.8363 12.8965 14.9717L12.2881 15.7666C12.3926 15.999 12.5251 16.218 12.6836 16.4209L13.7236 16.3135C13.8919 16.296 14.0628 16.33 14.2109 16.4121C14.3592 16.4943 14.4787 16.6207 14.5498 16.7754L14.9678 17.6846C15.2379 17.7161 15.5105 17.7152 15.7812 17.6836L16.1992 16.7754C16.2705 16.6208 16.3908 16.4941 16.5391 16.4121C16.6872 16.3302 16.8573 16.2959 17.0254 16.3135L18.0645 16.4209C18.2235 16.2177 18.3562 15.9983 18.4609 15.7656L17.8535 14.9717C17.7501 14.8363 17.6934 14.6709 17.6934 14.5C17.6934 14.3291 17.7501 14.1637 17.8535 14.0283L18.4609 13.2324C18.3565 13.0003 18.2239 12.781 18.0654 12.5781L17.0254 12.6865C16.8572 12.704 16.6872 12.6699 16.5391 12.5879C16.3907 12.5057 16.2704 12.3794 16.1992 12.2246L15.7812 11.3145ZM16.0957 14.5C16.0957 14.3242 16.0235 14.1528 15.8896 14.0244C15.7553 13.8957 15.5702 13.8213 15.375 13.8213C15.18 13.8214 14.9956 13.8959 14.8613 14.0244C14.7274 14.1528 14.6543 14.3242 14.6543 14.5C14.6543 14.6758 14.7274 14.8472 14.8613 14.9756C14.9956 15.1041 15.18 15.1786 15.375 15.1787C15.5702 15.1787 15.7553 15.1043 15.8896 14.9756C16.0235 14.8472 16.0957 14.6758 16.0957 14.5ZM17.207 14.5C17.207 14.9731 17.0107 15.4244 16.666 15.7549C16.3217 16.085 15.8567 16.2676 15.375 16.2676C14.8935 16.2675 14.4292 16.0848 14.085 15.7549C13.7402 15.4244 13.5439 14.9731 13.5439 14.5C13.5439 14.0269 13.7402 13.5756 14.085 13.2451C14.4292 12.9152 14.8935 12.7325 15.375 12.7324C15.8567 12.7324 16.3217 12.915 16.666 13.2451C17.0107 13.5756 17.207 14.0269 17.207 14.5Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9688 2C14.2105 2 14.4467 2.07048 14.6494 2.20215C14.8521 2.33388 15.0131 2.52127 15.1113 2.74219L17.2812 7.625H18.125C18.2908 7.625 18.4502 7.69041 18.5674 7.80762C18.6846 7.92483 18.75 8.08424 18.75 8.25C18.75 8.41576 18.6846 8.57517 18.5674 8.69238C18.4502 8.80959 18.2908 8.875 18.125 8.875H17.5V9.5H16.25V8.875H2.5V12.625H10.375V13.875H5.625V15.125C5.625 15.4565 5.49321 15.7744 5.25879 16.0088C5.02437 16.2432 4.70652 16.375 4.375 16.375H2.5C2.16848 16.375 1.85063 16.2432 1.61621 16.0088C1.38179 15.7744 1.25 15.4565 1.25 15.125V8.875H0.625C0.45924 8.875 0.299827 8.80959 0.182617 8.69238C0.065407 8.57517 0 8.41576 0 8.25C0 8.08424 0.065407 7.92483 0.182617 7.80762C0.299827 7.69041 0.45924 7.625 0.625 7.625H1.46875L3.63867 2.74219C3.73689 2.52127 3.89786 2.33388 4.10059 2.20215C4.30328 2.07048 4.53954 2 4.78125 2H13.9688ZM2.5 13.875V15.125H4.375V13.875H2.5ZM4.78125 3.25L2.83691 7.625H15.9131L13.9688 3.25H4.78125Z" fill="black"/>
                        <path d="M5.625 10.125C5.79076 10.125 5.95017 10.1904 6.06738 10.3076C6.18459 10.4248 6.25 10.5842 6.25 10.75C6.25 10.9158 6.18459 11.0752 6.06738 11.1924C5.95017 11.3096 5.79076 11.375 5.625 11.375H4.375C4.20924 11.375 4.04983 11.3096 3.93262 11.1924C3.81541 11.0752 3.75 10.9158 3.75 10.75C3.75 10.5842 3.81541 10.4248 3.93262 10.3076C4.04983 10.1904 4.20924 10.125 4.375 10.125H5.625Z" fill="black"/>
                    </svg>
                </span>
                <span class="sf__header-selection__copy">
                    <span class="sf__header-selection__eyebrow">Current Selection</span>
                    <strong>{{ selection.vehicleLabel }}</strong>
                </span>
                <span class="sf__header-selection__change">
                    Change
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M4 7H13M17 7H20M15 5C16.1 5 17 5.9 17 7C17 8.1 16.1 9 15 9C13.9 9 13 8.1 13 7C13 5.9 13.9 5 15 5ZM4 17H7M11 17H20M9 15C10.1 15 11 15.9 11 17C11 18.1 10.1 19 9 19C7.9 19 7 18.1 7 17C7 15.9 7.9 15 9 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
            </button>

            <Teleport to="body" :disabled="!modalSheet">
                <EditSelectionSheet
                    v-if="sheetOpen"
                    ref="editSheet"
                    :modal="modalSheet"
                    :rows="selection.rows"
                    :collection-url="viewCollectionUrl"
                    :show-view-parts="!isCurrentCollection"
                    @close="closeSheet"
                    @edit="editStep"
                    @changeVehicle="changeVehicle"
                    @viewParts="viewParts"
                />
            </Teleport>
        </template>
    </div>
</template>

<script>
import EditSelectionSheet from './EditSelectionSheet.vue';
import {
    getCollectionUrl,
    getCurrentSelection,
    normalizeSelection,
    storeCurrentSelection
} from '../helpers/currentSelection';

export default {
    props: {
        hideEmpty: {
            type: [Boolean, String],
            default: false
        },
        menu: {
            type: [Boolean, String],
            default: false
        }
    },

    components: {
        EditSelectionSheet
    },

    data() {
        return {
            selection: null,
            sheetOpen: false,
            modalSheet: false,
            returnFocus: null
        };
    },

    computed: {
        hasSelection() {
            return !!this.selection;
        },

        isMenu() {
            return this.menu === true || this.menu === 'true';
        },

        shouldHideEmpty() {
            return this.hideEmpty === true || this.hideEmpty === 'true';
        },

        viewCollectionUrl() {
            return getCollectionUrl(this.selection);
        },

        isCurrentCollection() {
            if (!this.viewCollectionUrl) return false;

            const normalizePath = path => path.replace(/\/+$/, '') || '/';
            const collectionUrl = new URL(this.viewCollectionUrl, window.location.origin);

            if (normalizePath(window.location.pathname) !== normalizePath(collectionUrl.pathname)) {
                return false;
            }

            const currentParams = new URLSearchParams(window.location.search);

            return Array.from(collectionUrl.searchParams).every(([key, value]) => (
                currentParams.get(key) === value
            ));
        }
    },

    mounted() {
        this.refreshSelection();
        document.addEventListener('click', this.handleOutsideClick);
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('seatshop:current-selection-updated', this.refreshSelection);
        document.addEventListener('seatshop:current-selection-cleared', this.refreshSelection);
        document.addEventListener('seatshop:vehicle-sheet-open', this.closeOtherSheet);
        document.addEventListener('seatshop:vehicle-drawer-open', this.closeOtherSheet);
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('seatshop:current-selection-updated', this.refreshSelection);
        document.removeEventListener('seatshop:current-selection-cleared', this.refreshSelection);
        document.removeEventListener('seatshop:vehicle-sheet-open', this.closeOtherSheet);
        document.removeEventListener('seatshop:vehicle-drawer-open', this.closeOtherSheet);
    },

    methods: {
        refreshSelection(event) {
            this.selection = normalizeSelection(event?.detail?.selection) || getCurrentSelection();

            if (this.selection) {
                storeCurrentSelection(this.selection);
            } else {
                this.closeSheet();
            }
        },

        toggleSheet() {
            if (this.sheetOpen) {
                this.closeSheet();
                return;
            }

            this.modalSheet = window.matchMedia('(max-width: 989px)').matches;
            this.returnFocus = this.$el.closest('header-drawer')?.querySelector('summary') || document.activeElement;
            // Close navigation before mounting a sheet outside its hidden/translated container.
            document.dispatchEvent(new CustomEvent('seatshop:vehicle-sheet-open'));
            this.sheetOpen = true;
        },

        closeSheet(restoreFocus = true) {
            if (!this.sheetOpen) return;
            this.sheetOpen = false;
            if (restoreFocus && this.modalSheet) this.returnFocus?.focus({ preventScroll: true });
        },

        closeOtherSheet() {
            this.closeSheet(false);
        },

        handleOutsideClick(event) {
            if (!this.sheetOpen || this.$el.contains(event.target) || this.$refs.editSheet?.$el.contains(event.target)) return;
            this.closeSheet();
        },

        handleKeydown(event) {
            if (event.key === 'Escape') {
                this.closeSheet();
            }
        },

        openDrawer(detail = {}) {
            document.dispatchEvent(new CustomEvent('seatshop:vehicle-drawer-open-request', { detail }));
        },

        async editStep(step) {
            const selection = this.selection;
            this.closeSheet(false);
            await this.$nextTick();
            this.openDrawer({
                step,
                selection,
                resetAfterStep: step
            });
        },

        async changeVehicle() {
            this.closeSheet(false);
            await this.$nextTick();
            this.openDrawer({
                step: 'vehicle',
                changeVehicle: true
            });
        },

        viewParts(event) {
            if (!this.isCurrentCollection) return;

            event.preventDefault();
            this.closeSheet();
        }
    }
};
</script>
